'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionInset = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Accordion Inset - Accordion inside accordion
 *    Styles for controlling accordions.
 *    Will init on all [data-accordion]'s by default, but can be supered as well
 *
 *  Version:
 *    1.0.0 - 2018/12/03
 */
var SLIDE_SELECTOR = '[data-accordion-slide-inset]';
var TITLE_SELECTOR = '[data-accordion-title-inset]';
var BODY_SELECTOR = '[data-accordion-body-inset]';

var EXPANDED_CLASS = 'is-expanded';

var AccordionInset = exports.AccordionInset = function () {
  function AccordionInset(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, AccordionInset);

    this.container = container;

    //Settings
    this.allowMultiple = container.attr('data-multiple') == "true" ? true : false;

    //Setup data attributes
    var slides = container.find(SLIDE_SELECTOR);
    slides.each(function (i, e) {
      _this.setSlideIndex((0, _jquery2.default)(e), i);
    });

    //Event listeners
    container.on('click', TITLE_SELECTOR, function (e) {
      return _this.onTitleClick(e);
    })
    // .on('touchmove', e => this.touchMoved = true )
    // .on('click touchend', e => this.touchMoved = false )
    ;
  }

  (0, _createClass3.default)(AccordionInset, [{
    key: 'setSlideIndex',
    value: function setSlideIndex(slide, index) {
      //Does this node already have an index?
      var existingIndex = slide.attr('data-index');
      if (existingIndex) return; //Yes, don't do anything

      //If there's no index supplied, find an available one.
      if ((typeof index === 'undefined' ? 'undefined' : (0, _typeof3.default)(index)) === (typeof undefined === 'undefined' ? 'undefined' : (0, _typeof3.default)(undefined))) {
        var i = 0;
        while (true) {
          //Is this index taken by another slide?
          var existing = this.container.find(SLIDE_SELECTOR + '[data-index="' + i + '"]');
          if (existing.length) {
            i++;continue;
          } //Taken
          index = '' + i;
          break;
        }
      }

      //Setup indexes
      slide.attr('data-index', index);
      slide.find(TITLE_SELECTOR + ',' + BODY_SELECTOR).attr('data-index', index);
    }
  }, {
    key: 'getSlide',
    value: function getSlide(index) {
      //Find slide by index
      return this.container.find(SLIDE_SELECTOR + '[data-index="' + index + '"]');
    }
  }, {
    key: 'useSlide',
    value: function useSlide(index) {
      //Get slide
      var slide = this.getSlide(index);
      var slideBody = slide.find(BODY_SELECTOR);
      var slideBodies = this.container.find(BODY_SELECTOR);

      var transition = {
        duration: 200,
        specialEasing: {
          'transition-timing-function': 'cubic-bezier(0.165, 0.84, 0.44, 1)'
        }
      };

      //If Multiple just toggle
      if (this.allowMultiple && (0, _jquery2.default)(window).width() > ResponsiveSizes.medium) {
        slideBody.slideToggle(transition);
        slide.toggleClass(EXPANDED_CLASS);
        return;
      }

      //Not multple, is currently open?
      var close = slide.hasClass(EXPANDED_CLASS);
      this.container.find(SLIDE_SELECTOR).removeClass(EXPANDED_CLASS); //Close all
      slideBodies.slideUp(transition);
      if (close) return; //If was open, leave closed

      //Was not opened before, open now.
      slide.addClass(EXPANDED_CLASS);
      slideBody.slideDown(transition);
    }
  }, {
    key: 'onTitleClick',
    value: function onTitleClick(e) {
      // if(this.touchMoved) return;

      //Get Element
      var self = (0, _jquery2.default)(e.currentTarget);
      var slideContainer = self.parent(SLIDE_SELECTOR);
      this.setSlideIndex(slideContainer);

      var index = parseInt(self.attr('data-index')); //Get Index
      if (isNaN(index)) return; //Has index?

      //Set Slide
      this.useSlide(index);
    }
  }]);
  return AccordionInset;
}();